// Booststrap - pouze pouzite moduly:
import { Alert, Button, Collapse, Dropdown, Modal, Offcanvas, Popover, Tab } from 'bootstrap';
// import Calendar from 'color-calendar';
import { SwipeEventListener } from 'swipe-event-listener';
import { tns } from 'tiny-slider';

import { IWebsite } from '../../../typings/website';
// import { MapMapyCz } from './components/map.MapyCz';
// import { CalendarWidget, renderEventDialog } from './components/mod.calendar';
import { ServerMap } from './components/mod.servermap';
import { processPageContent } from './components/pageContent';
import { initPhotoSwipeGallery, initPhotoSwipeSingleImage } from './components/photoSwipeGallery';
// import { getNameDays } from './components/svatek';
import {
    FADE_IN_ANIMATION_TIME,
    FADE_OUT_ANIMATION_TIME,
    NAVIGATION_ANIMATION_DURATION,
    SCREEN_WIDTH_TABLET,
} from './constants';
import { trackCustomEvent } from './helpers/analytics';
import { createCookie, eraseCookie, getCookie, readCookie } from './helpers/cookies';
import { markInvalidControls } from './helpers/forms';
import {
    addClass,
    delay,
    fadeIn,
    fadeOut,
    fadeToggle,
    getChildren,
    getClosesParent,
    getRandomString,
    getURLParameter,
    getWindowsHeight,
    hasClass,
    removeClass,
    stripHtml,
} from './helpers/generic';
import { modalBackdropResize } from './helpers/modals';

declare global {
    interface Window {
        __WEBSITE__: IWebsite;
    }
}
const website: IWebsite = window.__WEBSITE__ || {
    App: {},
    AppSettings: {},
    AppStrings: {},
};

website.App = {
    ...website.App,
    Bootstrap: {
        Alert,
        Button,
        //Carousel,
        Collapse,
        Dropdown,
        Modal,
        Offcanvas,
        Popover,
        //ScrollSpy,
        Tab,
        //Toast,
        //Tooltip
    },
    fadeIn,
    fadeOut,
    fadeToggle,
    hasClass,
    addClass,
    removeClass,
    getClosesParent,
    getChildren,
    stripHtml,
    getURLParameter,
    getWindowsHeight,
    trackCustomEvent,
    delay,
    createCookie,
    readCookie,
    getCookie,
    eraseCookie,
    getRandomString,
    modalBackdropResize,
    processPageContent,
    // Forms
    markInvalidControls,
    // PhotoSwipe Lightbox
    initPhotoSwipeSingleImage,
    initPhotoSwipeGallery,
    // Svatek:
    // getNameDays,
    // Sitemap:
    ServerMap,
    // dynamicka mapa:
    // MapMapyCz,
    // TinySlider:
    tns,
    // Color Calendar:
    // ColorCalendar: Calendar,
    // CalendarWidget,
    // renderEventDialog,
    SwipeEventListener: SwipeEventListener as any,
};

website.AppSettings = {
    ...website.AppSettings,
    SCREEN_WIDTH_TABLET,
    NAVIGATION_ANIMATION_DURATION,
    FADE_IN_ANIMATION_TIME,
    FADE_OUT_ANIMATION_TIME,
    calendarSelectedYear: new Date().getFullYear(),
    calendarSelectedMonth: new Date().getMonth() + 1,
};

window.__WEBSITE__ = website;
